import React, { FC, PropsWithChildren, useContext, useMemo } from 'react';
import { IHttpClient } from '@wix/http-client';
import { ChatHttpClient } from '../client/ChatHttpClient';
import { TokenAuthenticatedHttpClientFactory } from '../utils/TokenAuthenticatedHttpClientFactory';
import { useAuthTokenContext } from './AuthTokenContext';

export interface IHttpClientsContext {
  httpClient: IHttpClient;
  chatHttpClient: IHttpClient;
  chatClient: ChatHttpClient;
}

const clientFactory = new TokenAuthenticatedHttpClientFactory();

export const HttpClientsContext = React.createContext<IHttpClientsContext | null>(null);

export const HttpClientsContextProvider: FC<PropsWithChildren<{ useIndividualAssistant?: boolean }>> = ({ children, useIndividualAssistant }) => {
  const { authToken } = useAuthTokenContext();

  const httpClient = useMemo(() => clientFactory.createHttpClient(authToken), [authToken]);
  const chatHttpClient = useMemo(
    () => clientFactory.createHttpClient(authToken, { baseURL: `/${useIndividualAssistant ? 'individuals-chat' : 'uou-chat'}` }),
    [authToken, useIndividualAssistant],
  );
  const chatClient = useMemo(() => new ChatHttpClient(chatHttpClient), [chatHttpClient]);

  return <HttpClientsContext.Provider value={{ httpClient, chatHttpClient, chatClient }}>{children}</HttpClientsContext.Provider>;
};

export function useHttpClientsContext() {
  const context = useContext(HttpClientsContext);

  if (!context) {
    throw new Error('HttpClientsContext must be used within an HttpClientsContextProvider');
  }

  return context;
}
